<template>
  <div class="px-5 py-4">
    <div class="flex flex-col">
      <div class="flex flex-col" style="gap:1.5rem;">
        <div class="flex flex-col" style="gap:0.5rem">
          <div class="plusGreyDarken4--text" style="font-size:1.438rem;">{{$t("message.products_memberships_plus.sale_without_product")}}</div>
          <div class="plusGreyDarken2--text">{{$t("message.products_memberships_plus.sale_withour_product_explained")}}</div>
        </div>
        <div>
          <v-text-field outlined dense maxlength="50" :label="$t('message.name')" v-model="itemName"></v-text-field>
          <v-textarea outlined :label="$t('message.description')" v-model="itemDescription"></v-textarea>
          <v-row>
            <v-col>
              <v-text-field outlined dense :label="$t('message.price')" v-mask="mask1" v-model="price"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field outlined dense v-mask="mask2" v-model="priceDecimal"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="2">
              <v-text-field outlined dense disabled v-model="currencyText" :label="$t('message.currency')">
              </v-text-field>
            </v-col>
          </v-row>
          <div class="flex items-center" style="gap:1.25rem;">
            <v-autocomplete @change="getPaymentMethod()" v-model="selectedMember" :items="members"
              :label="$t('message.pick_member')" item-text="text" item-value="value" clearable outlined
              dense></v-autocomplete>
            <div class="plusGreyDarken1--text pb-6">{{ $t("message.or") }}</div>
            <v-text-field outlined dense label="Email" v-model="email"></v-text-field>
          </div>
        </div>
      </div>
      <div class="flex" style="gap:1.25rem;">
        <PlusButton :disabled="!stripeReady || !itemDescription || !itemName"
          v-if="validQuantity && (email || selectedMember) && itemName" @click="initCheckout()">
          <v-icon>mdi-credit-card-outline</v-icon>
          {{ $t("message.pay_new_card") }}
        </PlusButton>
        <PlusButton intent="primary" :disabled="!itemDescription || !itemName"
          v-if="validQuantity && (email || selectedMember) && itemName" @click="payCash()">
          <v-icon>mdi-cash</v-icon>
          {{ $t("message.pay_cash") }}
        </PlusButton>
        <PlusButton @click="cancel()">
          {{
            $t("message.cancel")
          }}
        </PlusButton>
      </div>
    </div>
  </div>
</template>

<script>

import Api from "@/services/Api";
import PlusButton from "@/components/plus/PlusButton";
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask
  },
  components: {
    PlusButton
  },
  data() {
    return {
      selectedMember: this.$route.query.userId
        ? this.$route.query.userId
        : null,
      loading: true,
      itemName: null,
      itemDescription: null,
      stripeSessionId: null,
      checkoutInitialized: false,
      validQuantity: true,
      currencyText: null,
      price: null,
      mask1: "####",
      mask2: "##",
      priceDecimal: "00",
      members: [],
      back: false,
      quantity: 1,
      academyImage: null,
      paymentForm: false,
      currency: null,
      saveCreditCard: true,
      email: null,
      stripeReady: false,
      handlingCharges: false,
      paymentsReady: false,
      paymentMethod: null,
      automaticTaxesEnabled: false
    };
  },
  created() {
    Api()
      .get(
        "admins/academy/" +
        this.$store.state.managedAcademy +
        "/is_connected/stripe"
      )
      .then((response) => {
        this.stripeReady = response.data.stripeConnected;
      });
    Api()
      .get("admins/academy/" + this.$store.state.selectedAcademy)
      .then((response) => {
        this.currency = response.data.currency;
        this.currencyText = response.data.currency
          ? response.data.currency
          : "???";
        this.paymentsReady = response.data.paymentsReady;
        this.academyImage = response.data.image;
        this.paymentsModule = response.data.paymentsModule;
        if (this.academy.configuration && this.academy.configuration.automaticTaxCalculation)
          this.automaticTaxesEnabled = true;
      });
    Api()
      .get("admins/academy/" + this.$store.state.selectedAcademy + "/members")
      .then((response) => {
        const data = response.data;
        if (data) {
          for (const m of data.approved) {
            this.members.push({ value: m._id, text: m.fName + " " + m.lName });
          }
          if (this.$route.query.userId) {
            this.selectedMember = this.$route.query.userId;
            this.getPaymentMethod();
          }
        }
      })
      .catch((e) => {
        if (e)
          this.showAlert("error", "Oops!", this.$t("message.error_generic"));
      });
  },
  watch: {
    quantity: {
      handler: function (newValue) {
        this.checkAmountValidity(newValue);
      },
    },
  },
  methods: {
    savedCardPurchase() {
      this.back = false;
      this.handlingCharges = true;
      const items = this.setupItems();
      if (!items || this.automaticTaxesEnabled) {
        this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        return;
      }
      const postData = {
        items: items,
        processedBy: "desk",
        buyer: this.selectedMember,
        quantity: this.quantity,
        email: this.email,
      };
      let postUrl =
        "payments/academy/" +
        this.$store.state.managedAcademy +
        "/onetime/savedcard";
      Api()
        .post(postUrl, postData)
        .then((response) => {
          const data = response.data;
          if (data) {
            this.navigateTo({
              name: "transactions",
              query: { status: "success" },
            });
          }
        })
        .catch((e) => {
          this.handlingCharges = false;
          this.waitingForPayment = false;
          if (e.response.status == 500) {
            const errData = e.response.data;
            this.showAlert(
              "error",
              this.$t("message.error_code") + ": " + errData.type,
              errData.message,
              15000
            );
          } else {
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          }
        });
    },
    getPaymentMethod() {
      if (!this.selectedMember) {
        this.paymentMethod = null;
      }
      Api()
        .get(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/customer/" +
          this.selectedMember
        )
        .then((response) => {
          if (response.data && response.data.paymentMethod) {
            this.paymentMethod = response.data.paymentMethod;
            if (this.paymentMethod.expYear) {
              let expDate = new Date();
              expDate.setFullYear(this.paymentMethod.expYear);
              expDate.setMonth(this.paymentMethod.expMonth - 1);
              this.paymentMethod.expDate = expDate;
              let today = new Date();
              if (expDate > today) this.paymentMethod.expired = false;
              else this.paymentMethod.expired = true;
            } else {
              //With the new payment we dont know exp date
              this.paymentMethod.expired = false;
            }
          } else {
            this.paymentMethod = null;
          }
        });
    },
    checkAmountValidity(q) {
      if (!isNaN(q) && q != "") {
        this.validQuantity = true;
      } else {
        this.validQuantity = false;
      }
      if (this.validQuantity && this.quantity <= 0) this.validQuantity = false;
    },
    payCash() {
      this.back = false;
      this.handlingCharges = true;
      const items = this.setupItems();
      if (!items) {
        this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        return;
      }
      const postData = {
        items: items,
        processedBy: "desk",
        buyer: this.selectedMember,
        quantity: this.quantity,
        email: this.email,
      };
      let postUrl =
        "payments/academy/" +
        this.$store.state.managedAcademy +
        "/onetime/cash/noproduct";
      Api()
        .post(postUrl, postData)
        .then((response) => {
          const data = response.data;
          if (data) {
            this.navigateTo({ name: "transactions" });
          }
        })
        .catch((e) => {
          this.handlingCharges = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    initCheckout(sendNotification) {
      //this.paymentForm = true;
      this.back = false;
      this.handlingCharges = true;
      const items = this.setupItems();
      if (!items) {
        this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        return;
      }

      const postData = {
        items: items,
        saveCreditCard: this.saveCreditCard ? this.saveCreditCard : null,
        processedBy: sendNotification ? "user" : "desk",
        buyer: this.selectedMember,
        quantity: this.quantity,
        email: this.email,
        sendNotification: sendNotification,
      };
      if (this.paymentsModule == 'infinicept') {
        postData.currencySymbol = this.currencySymbol;
        postData.total = items[0].amountDecimal;
        this.navigateTo({
          name: "inifnicept-checkout",
          params: { transactionData: postData }
        });
        return;
      }
      var postUrl =
        "payments/academy/" +
        this.$store.state.managedAcademy +
        "/onetime/checkout/noproduct";
      Api()
        .post(postUrl, postData)
        .then((response) => {
          const data = response.data;
          if (data) {
            if (!sendNotification) {
              this.navigateTo({
                name: "striperedirect_session",
                params: { sessionId: data.id },
              });
            } else {
              this.handlingCharges = false;
              this.checkoutInitialized = true;
              this.back = true;
              this.showAlert(
                "success",
                this.$t("message.success"),
                this.$t("message.charge_notification"),
                8000
              );
            }
          }
        })
        .catch((e) => {
          this.handlingCharges = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    setupItems() {
      let image = this.userImg(this.academyImage);
      if (this.priceDecimal == "") this.priceDecimal = "00";
      else if (this.priceDecimal.length == 1)
        this.priceDecimal = this.priceDecimal + "0";
      const amount = new Number(this.price + this.priceDecimal);
      const amountDecimal = new Number(this.price + "." + this.priceDecimal);
      if (!amountDecimal || amountDecimal <= 0) return null;
      const items = [
        {
          name: this.itemName,
          description: this.itemDescription,
          images: [image],
          amount: amount.valueOf(),
          amountDecimal: amountDecimal.valueOf(),
          currency: this.currency,
          quantity: this.quantity,
        },
      ];
      return items;
    },
    cancel() {
      if (this.stripeSessionId) {
        this.handlingCharges = true;
        this.navigateTo({ name: "products" });
      } else {
        this.navigateTo({ name: "products" });
      }
    },
  },
}
</script>

<style scoped>
</style>
